import React, { useState, useEffect } from 'react';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { fetchApiKeys, deleteApiKey } from '~/redux/actions/apiKeys-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

//Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION_WITHOUT_PAGE_SIZE } from '~/utils/constants';

// Components
import Table from './ApiKeysListing';
import CreateApiKeys from './CreateApiKey';
import RotateApiModal from './RotateApiModal';
import EditApiModal from './EditApiKey';
import ConfirmModal from '~/components/General/ConfirmModal';
import OlcButton from '~/components/General/OlcButton';

// MUI Components
import { Box, Typography, GlobalStyles } from '@mui/material';

// images
import { DeleteCDCIcon, ContactDetailsDeleteCIcon } from '~/assets/images';

// styles
import './styles.scss';

const index = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_WITHOUT_PAGE_SIZE);
  const [createApiModal, setCreateApiModal] = useState(false);
  const [rotateApiModal, setRotateApiModal] = useState(false);
  const [editApiModal, setEditApiModal] = useState(false);
  const [selectedApiKeyData, setSelectedApiKeyData] = useState(null);

  const [selectedApi, setSelectedApi] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    message: '',
    header: '',
    icon: '',
    loading: false,
    handleOk: () => {},
    handleClose: () => {},
    successButtonName: '',
    cancelButtonName: '',
  });

  const currentMode = useSelector((state) => state.userReducers.user.isLiveMode || false);

  const dispatch = useDispatch();

  const deleteExistingApiKey = async (apiIdToDelete) => {
    try {
      setConfirmModal((prev) => ({ ...prev, loading: true }));
      const response = await dispatch(deleteApiKey(apiIdToDelete));
      if (!response?.data) {
        dispatch(failure(response ? MESSAGES.GENERAL_ERROR : MESSAGES.NO_RESPONSE_ERROR));
        setConfirmModal((prev) => ({ ...prev, loading: false }));
        return;
      }
      dispatch(success(response.data.message));
      dispatch(fetchApiKeys(pagination));
      setConfirmModal((prev) => ({ ...prev, open: false, loading: false }));
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message || MESSAGES.GENERAL_ERROR));
      setConfirmModal((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    let isActive = true;

    dispatch(fetchApiKeys(pagination)).finally(() => {
      if (isActive) {
        setInitialLoad(false);
      }
    });

    return () => {
      isActive = false;
    };
  }, [dispatch, pagination.page, pagination.pageSize, currentMode]);

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#f9fafb' } }} />
      <Box className="olcWrapper olcSettingsListPage apiKeysPageWrapper">
        <Box className="olcScreenCard olcSettingsListCard apiKeysScreenCard">
          <Box className="olcHeaderWrap">
            <Box>
              <Typography className="pageTitle">{MESSAGES.SETTINGS.API_KEYS.TITLE}</Typography>
            </Box>
            <Box className="pageNewBtn">
              <OlcButton variant="primary" onClick={() => setCreateApiModal(true)}>
                {MESSAGES.SETTINGS.API_KEYS.CREATE_BUTTON_TEXT}
              </OlcButton>
            </Box>
          </Box>
          <Table
            setDeleteApiModal={(apiId) => {
              setSelectedApi(apiId);
              setConfirmModal({
                open: true,
                message: MESSAGES.SETTINGS.API_KEYS.DELETE.HEADING,
                header: MESSAGES.SETTINGS.API_KEYS.DELETE.TITLE,
                icon: ContactDetailsDeleteCIcon,
                loading: false,
                handleOk: () => deleteExistingApiKey(apiId),
                handleClose: () => setConfirmModal((prev) => ({ ...prev, open: false })),
                successButtonName: MESSAGES.SETTINGS.API_KEYS.DELETE.SUBMIT_BUTTON,
                cancelButtonName: MESSAGES.SETTINGS.API_KEYS.DELETE.CANCEL_BUTTON,
              });
            }}
            setRotateApiModal={setRotateApiModal}
            setEditApiModal={setEditApiModal}
            setSelectedApi={setSelectedApi}
            setSelectedApiKeyData={setSelectedApiKeyData}
            updatePagination={setPagination}
            pagination={pagination}
            initialLoad={initialLoad}
          />
        </Box>
      </Box>
      <CreateApiKeys
        openModal={createApiModal}
        handleCloseModal={() => setCreateApiModal(false)}
        pagination={pagination}
        updatePagination={setPagination}
      />
      <RotateApiModal
        openModal={rotateApiModal}
        handleCloseModal={() => setRotateApiModal(false)}
        selectedApi={selectedApi}
        pagination={pagination}
      />
      <EditApiModal
        openModal={editApiModal}
        handleCloseModal={() => setEditApiModal(false)}
        selectedApi={selectedApi}
        selectedApiKeyData={selectedApiKeyData}
        pagination={pagination}
      />
      <ConfirmModal openConfirmModal={confirmModal} />
    </>
  );
};

export default index;
